import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

/**
 * Shared bottom-sheet / centered-modal shell used by every Settings Hub
 * detail screen. Slides up from the bottom on mobile, centers on desktop.
 * Each sheet provides its own header content and body; the shell handles
 * the chrome, escape-to-close, backdrop, and sticky title row.
 */
export const SheetShell = ({ open, onClose, title, children, footer, testId }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[60] bg-black/45 flex items-end sm:items-center justify-center"
        onClick={onClose}
        data-testid={testId || 'settings-sheet'}
      >
        <motion.div
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', damping: 32, stiffness: 320 }}
          className="bg-[#FDFBF7] w-full h-[100dvh] sm:h-auto sm:max-h-[82vh] sm:max-w-md sm:rounded-2xl rounded-t-2xl flex flex-col overflow-hidden shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between px-5 pt-4 pb-3 border-b border-[#E8E6DF]/50 flex-shrink-0">
            <h2
              className="text-xl sm:text-[22px] text-[#2C3333]"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              {title}
            </h2>
            <button
              type="button"
              onClick={onClose}
              className="p-2 rounded-full hover:bg-[#F5F3EF] transition-colors"
              aria-label="Close"
              data-testid={`${testId || 'settings-sheet'}-close`}
            >
              <X size={20} className="text-[#5C6666]" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
          {footer && (
            <div className="px-5 py-3 border-t border-[#E8E6DF]/50 bg-white/60 flex-shrink-0">
              {footer}
            </div>
          )}
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default SheetShell;
